module.exports = __webpack_public_path__ + "static/media/black-sea-bass.35d0459d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/black-sea-bass.png
// module id = 299
// module chunks = 0